export class Perspective {
  organization: string;
  name: string;
  label: string;
  description?: string;
  permission: Permission;
  constructor(data: any) {
    this.organization = data.organization || '';
    this.label = data.label || '';
    this.name = data.name || '';
    this.description = data.description || '';
    this.permission = new Permission(data.permission || {});
  }
}

export class Permission {
  services: PermissionEntity[];
  targets: PermissionEntity[];
  resourceTags: { enabled: boolean; allowed: string[] };
  awsService: boolean;
  usageType: boolean;
  resourceId: boolean;
  constructor(data: any) {
    this.services = Array.isArray(data.services)
      ? data.services.map((s: any) => new PermissionEntity(s))
      : [];
    this.targets = Array.isArray(data.targets)
      ? data.targets.map((t: any) => new PermissionEntity(t))
      : [];
    this.resourceTags = data.resource_tags
      ? {
          enabled: data.resource_tags.enabled ?? false,
          allowed: data.resource_tags.allowed ?? [],
        }
      : { enabled: false, allowed: [] };
    this.awsService = data.aws_service ?? false;
    this.usageType = data.usage_type ?? false;
    this.resourceId = data.resource_id ?? false;
  }
}

export class PermissionEntity {
  label: string;
  name: string;
  constructor(data: any) {
    this.label = data.label || '';
    this.name = data.name || '';
  }
}
